import { render, staticRenderFns } from "./ApiDocumentation.vue?vue&type=template&id=a0bf6654&scoped=true"
import script from "./ApiDocumentation.vue?vue&type=script&lang=js"
export * from "./ApiDocumentation.vue?vue&type=script&lang=js"
import style0 from "./ApiDocumentation.vue?vue&type=style&index=0&id=a0bf6654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf6654",
  null
  
)

export default component.exports